<template>
	<div
		class="side-nav"
		:class="{ fixedwidth: menuStatus, trans: !menuStatus }"
		@mouseenter="cancelCollapse"
		@mouseleave="scheduleCollapse"
	>
		<div class="side-menu-main">
			<ul class="list-unstyled">
				<li
					v-for="menu in menuItems"
					:key="menu.label"
					class="pointer"
					@mouseenter="menu.isHovered = true"
					@mouseleave="menu.isHovered = false"
					@click="
						menu.childRoutes.length > 0
							? (menu.showChildRoutes = !menu.showChildRoutes)
							: menu.onClick($router, $route)
					"
					:style="menu.childRoutes.length ? { width: '93%' } : {}"
					v-show="showSidebarMenu(menu)"
				>
					<div
						class="d-flex justify-content-between align-items-center fs-16"
						:class="
							checkActive(menu)
								? 'activenavclass activenavclass-back fw-600'
								: 'inactivenavclass inactivenavclass-back fw-500'
						"
					>
						<div>
							<img class="mr-1" :src="bindSidebarIcon(menu)" />
							<span class="pl-2">{{ menu.label }}</span>
						</div>
						<template v-if="menu.childRoutes.length > 0">
							<img
								v-if="menu.showChildRoutes"
								src="../../assets/sidebar/sidebarUpArrow.svg"
								alt=""
							/>
							<img
								v-else
								src="../../assets/sidebar/sidebardownarrow.svg"
								alt=""
							/>
						</template>
					</div>
					<b-collapse
						v-if="menu.childRoutes.length > 0"
						v-model="menu.showChildRoutes"
						class="ml-3 mt-2 pl-4"
					>
						<div
							v-for="submenu in menu.childRoutes"
							:key="submenu.label"
							:class="
								checkActive(submenu)
									? 'selected-suboption'
									: 'unselected-suboption'
							"
							class="pointer"
							@mouseenter="submenu.isHovered = true"
							@mouseleave="submenu.isHovered = false"
							@click.stop="submenu.onClick($router)"
						>
							<div v-if="submenu.isHovered" class="sel-line-sidebar"></div>
							{{ submenu.label }}
						</div>
					</b-collapse>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import menuItems from "@/utils/sideBarMenu.js";
export default {
	name: "SideBar",
	data() {
		return {
			collapseTimeout: null,
			menuItems: menuItems,
			mini: true,
			dropValue: false,
			title: {},
		};
	},
	watch: {
		title(value) {
			this.$store.commit("userVUEX/setPageTitle", value);
		},
	},
	computed: {
		...mapGetters(["roles"]),
		...mapGetters("userVUEX", {
			menuStatus: "getMenuStatus",
			userInfo: "getUserInfo",
		}),
	},
	methods: {
		bindSidebarIcon(menu) {
			let iconFile;  
			try {
				iconFile = menu.isHovered
					? menu.hoverIcon
					: this.checkActive(menu)
					? menu.activeIcon
					: menu.icon;

				return require(`@/assets/sidebar/${iconFile}`);
			} catch (e) {
				console.warn("Icon not found:", menu.label, iconFile);
				return "";
			}
		},
		checkActive(menu) {
			if (menu.label == "Job Search") {
				return (
					this.$route.name === "JobSearch" &&
					this.getBoolean(this.$route.query.bookmarked) !== true
				);
			} else if (menu.label == "Saved Jobs") {
				return (
					this.$route.name === "JobSearch" &&
					this.getBoolean(this.$route.query.bookmarked) === true
				);
			} else if (menu.childRoutes?.length) {
				return menu.childRoutes.some(
					(child) =>
						child.routeName && child.routeName.includes(this.$route.name)
				);
			} else if (menu.routeName && menu.routeName.includes(this.$route.name)) {
				return true;
			}

			return false;
		},
		showSidebarMenu(menu) {
			if (menu.label == "My Interview") {
				return this.userInfo.isPanelistVerified;
			}
			return true;
		},
		scheduleCollapse() {
			this.collapseTimeout = setTimeout(() => {
				this.menuItems.forEach((item) => (item.showChildRoutes = false));
			}, 300); // 300ms delay to allow cursor to move into submenu
		},
		cancelCollapse() {
			if (this.collapseTimeout) {
				clearTimeout(this.collapseTimeout);
				this.collapseTimeout = null;
			}
			this.menuItems.forEach((menu) => {
				menu.showChildRoutes = this.checkActive(menu);
			});
		},
		getBoolean(value) {
			return value === "true" || value === true;
		},
		closeSideBar() {
			this.$store.commit("userVUEX/setMenuStatus", false);
		},
		toggleSidebar() {
			if (this.mini) {
				document.getElementById("mySidebar").style.width = "300px";
				this.mini = false;
				// this.dropValue = true;
			} else {
				document.getElementById("mySidebar").style.width = "85px";
				// this.dropValue = false;
				this.$forceUpdate();
				this.mini = true;
			}
		},
		goToProgress() {
			let navigate = {
				name: "AssessmentMarketplace",
			};
			if (
				this.$route.name === "CandidateDashboard" &&
				this.$route.query.status
			) {
				navigate.query = {
					status: this.$route.query.status,
				};
			}
			this.$router.push(navigate);
		},
	},
};
</script>

<style>
.activenavclass {
	color: #20639b !important;
	font-family: "Montserrat", sans-serif;
}
.inactivenavclass {
	color: #324054 !important;
	font-family: "Montserrat", sans-serif;
}

.inactivenavclass-back-drop {
	border-radius: 8px;
	padding: 7px 8px;
}

.inactivenavclass-back-drop:hover {
	background-color: #eef3f7;
}

.activenavclass-back {
	border-radius: 8px;
	padding: 7px 8px;
}

.activenavclass-back:hover {
	background-color: #eef3f7;
}

.inactivenavclass-back {
	border-radius: 8px;
	padding: 7px 8px;
}

.inactivenavclass-back:hover {
	background-color: #20639b14;
}

.unsel-svg {
	background-color: #ffffff;
	height: 24px;
	width: 24px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.fixedwidth {
	width: 245px !important;
}
.trans {
	transition: width 1s;
}
.side-close {
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	width: 30px;
	height: 30px;
	border-radius: 14px;
	left: 222px;
	top: 40%;
	background: #ffffff;
	box-shadow: 0px 2px 11px rgba(0, 0, 0, 0.25);
	z-index: 9561545454;
}

.selected-suboption {
	background: #20639b14;
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 600;
	color: #20639b;
	border-radius: 4px;
	padding: 7px 10px;
	margin: 2px 0;
	position: relative;
}

.unselected-suboption {
	background: #fcfcfc;
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #344054;
	border-radius: 4px;
	padding: 7px 10px;
	margin: 2px 0;
	position: relative;
}

.unselected-suboption:hover {
	background: #20639b14;
}

.sel-line-sidebar {
	position: absolute;
	height: 100%;
	background-color: #c0c0c0;
	width: 2px;
	border-radius: 4px;
	left: -18px;
	top: 0px;
}
</style>
